import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import { StandardTabs, Tab } from "@ts-digital/vrc";
import Spinner from "../../general/spinner";
import WidgetSummaryCheckupImpresa from "../../widget/WidgetSummaryCheckupImpresa";
import { getCheckupSummary } from "../../../store/actions/rating/index";

import AnalyticsChart from "../../analytics/index";
import "./statisticStyle.css";
import { useLocation } from "react-router-dom";

const CheckupForm = props => {
  const { accountantUuidSelected, clientIdSelected } = props;
  const location = useLocation();
  /** Evita di usare la connect ed è più performante */
  const analytics = useSelector(state => state.analytics);
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);
  const [activeTab, setActiveTab] = useState(9);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCheckupSummary(auth, main.companySelected));
  }, []);

  const widgetIndex = location?.state?.index ? location.state.index : 2;

  useEffect(() => {
    if (widgetIndex === 1) {
      setActiveTab(8);
    } else if (widgetIndex === 2){
      setActiveTab(6);
    } else if (widgetIndex === 3){
      setActiveTab(7);
    }
  },[]);

  const handleTabChange = e => {
    setActiveTab(e + 6);
  };

  const renderCheckupWidget = (index, title) => {
    return (
      <div><WidgetSummaryCheckupImpresa
        index={index}
        title={title}
        accountantHasCheckupImpresa={true}        
        inCheckupPage={true}/>
      </div>);
  };

  const renderCheckupSummary = () => {
    return (<div  style={{
      display: "flex",
      flexDirection: "row",
      width: "100%"
    }}>
      <div style={{width: "calc(33% - 10px)", marginRight: "10px", marginBottom: "10px"}}>{renderCheckupWidget(1, "Rating creditizio")}</div>
      <div style={{width: "calc(33% - 10px)", marginRight: "10px", marginBottom: "10px"}}>{renderCheckupWidget(2, "DSCR")}</div>
      <div style={{width: "34%", marginBottom: "10px"}}>{renderCheckupWidget(3, <FormattedMessage id="checkup.sectorIndices" />)}</div>
    </div>);
  };

  const dataKpi =
    analytics && analytics.kpiList.status.ended ? analytics.kpiList.data : null;
  const dictionaryTitles = analytics ? analytics.kpiTitles.data : null;
  let statisticsArray = [];
  let statistics = [];
  let childrenList = {};
  let cont = 0;
  if (
    analytics &&
    (analytics.kpiList.status.ended || analytics.kpiList.status.error) &&
    !dataKpi
  )
    return (
      <div>
        {renderCheckupSummary()}
        <div>
          <FormattedMessage id="analytics.noChartOnCompany" />
        </div>
      </div>
    );

  if (dataKpi && dataKpi.data) {
    let counter = 0;
    for (let c = 0; c < dataKpi.data.length; c++) {
      let kpiCategories = dataKpi.data[c]["kpiScopes"];
      for (let d = 0; d < kpiCategories.length; d++) {
        if (
          kpiCategories[d].name === "lynfa.std.studio.name" ||
          kpiCategories[d].name === "sdi.std.statistiche_sdi.name"
        ) {
          continue;
        }
        counter++;
        for (let r = 0; r < kpiCategories[d].kpis.length; r++) {
          let idKpi = kpiCategories[d].kpis[r].id;
          const kpiName = kpiCategories[d].kpis[r].url;
          const parentId = kpiCategories[d].kpis[r].parentId;
          const kpiType = kpiCategories[d].kpis[r].kpiType.id;
          // esempio title: alyante.std.ciclo_attivo.fatturato_totale.title
          const analyticsTitleSplit = kpiCategories[d].kpis[r].title.split(".");
          let kpiTitle = null;
          analyticsTitleSplit.map(el => {
            kpiTitle = kpiTitle
              ? kpiTitle[el]
              : dictionaryTitles
                ? dictionaryTitles[el]
                : "";
            return kpiTitle;
          });

          if (parentId === null) {
            cont = idKpi;
            childrenList[cont] = [];
          } else if (kpiName) {
            childrenList[cont].push({ kpiName: kpiName, kpiTitle: kpiTitle });
          }
          const link2 = "graphId" + c + d + r;

          if (kpiName && kpiTitle) {
            statisticsArray.push(<AnalyticsChart
              key={"key_" + c + d + r}
              accountantUuidSelected={accountantUuidSelected}
              anchorId={link2}
              idDivForChart={"analyticsView-chart" + kpiName}
              fromStatistics={true}
              kpiTitle={kpiTitle}
              kpiName={kpiName}
              childrenList={childrenList[idKpi] ? childrenList[idKpi] : null}
              parentId={parentId}
              vatCode={clientIdSelected}
              analytics={analytics}
              kpiType={kpiType}
              isCheckup={true}
            />);
          }
        }

        statistics.splice(
          counter, 0, statisticsArray
        );
        statisticsArray = [];
      }
    }

    return (
      <div>
        {renderCheckupSummary()}
        <div style={{ backgroundColor: "#ffffff" }}>
          <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
            <StandardTabs
              style={{ marginBottom: "5px", overflow: "hidden", width: "100%" }}
              activeIndex={activeTab - 6}
              onChange={handleTabChange}
            >
              <Tab className="styleTab" key={6}>
              Indici della crisi
              </Tab>
              <Tab className="styleTab" key={7}>
              Indici di settore
              </Tab>
              <Tab className="styleTab" key={8}>
              Rating
              </Tab>
              <Tab className="styleTab" key={9}>
              Indicatori economico-finanziari
              </Tab>
            </StandardTabs>
          </div>

          <div
            style={{
              height: "100%",
              marginTop: "5px",
              overflowX: "hidden",
              display: activeTab === 8 || activeTab === 9 ? "flex" : null,
              flexFlow: activeTab === 9 ? "row wrap" : null,
              columnCount: activeTab === 6 ? 1 : 2
            }}
          >
            {statistics[activeTab]}
          </div>
        </div>
      </div>
    );
  } else if (analytics && analytics.kpiList.status.started) {
    return (
      <div>
        {renderCheckupSummary()}
        <Spinner
          size="large"
          tip={
            <span>
            Caricamento dati in corso. <br /> Si prega di attendere.
            </span>
          }
        /></div>
    );
  } return null;
};

export default CheckupForm;
